import React from "react"
import {Card, CardBody} from 'reactstrap'
//************************************//
import {trans} from '@utils'
//************************************//
const NoDataFound = (props) => {
  const {total, applyFilter, applyFilterFormData, noDataText, createNewAction} = props
  return (
    <Card className='mb-0 w-100'>
      <CardBody className='text-center'>
        <div className="d-flex flex-column justify-content-center align-items-center py-1">
          <h3>{noDataText || trans('gen.datatable.nodDataFound')}</h3>
          {createNewAction && _.size(applyFilter) === 0 && _.size(applyFilterFormData) === 0 && total === 0 ? <span className="mt-1">{createNewAction}</span> : null}
        </div>
      </CardBody>
    </Card>
  )
}

export default NoDataFound
